<template>
  <modal
    class="editTargetModal"
    name="editTargetModal"
    transition="pop-out"
    :width="650"
    :height="600"
  >
    <div class="modal__header">
      <span class="mr-3"
        ><img src="@/assets/img/building (1).svg" width="50" height="60"
      /></span>
      <h4>{{ $t("text.editTargetModal.title") }}</h4>
    </div>

    <div>
      <fieldset
        class="border p-3 form-group mt-3"
        style="margin: 0 auto; width: 85%"
      >
        <legend
          class="w-auto"
          style="color: #7d7885; font-size: 16px; padding: 10px"
        >
          {{ $t("text.editTargetModal.monthlyTarget") }}
        </legend>
        <div
          class="input__group__block mt-5"
          style="margin: 0 auto; width: 50%"
        >
          <label class="required">
            {{ $t("text.editTargetModal.salesProduct") }}
          </label>
          <div class="input__block" ref="description_input_div">
            <div class="input__block" ref="description_input_div">
              <select v-model="target.product">
                <option
                  :value="$t('text.editTargetModal.selectAProduct')"
                  disabled
                >
                  {{ $t("text.editTargetModal.selectAProduct") }}
                </option>
                <option
                  :value="prod"
                  v-for="(prod, index) in prodArray"
                  :key="index"
                >
                  {{ prod }}
                </option>
              </select>
            </div>
          </div>
          <div ref="sales_prod_error"></div>
        </div>
        <div
          class="input__group__block mt-4"
          style="margin: 0 auto; width: 50%"
        >
          <label class="required">
            {{ $tc("text.editTargetModal.target", 2) }}
          </label>
          <div class="input__block" ref="target_input_div">
            <input
              style="padding: 20px; width: 100%"
              type="number"
              :placeholder="$tc('text.editTargetModal.target', 1)"
              @blur="captureFormEvents($event)"
              v-model="target.quantity"
            />
          </div>

          <div ref="target_error"></div>
        </div>
        <div class="text-center py-3 mt-3">
          <button
            class="sales_target_btn text-center"
            @click="updateTarget($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.editTargetModal.title") }}<span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </fieldset>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";

export default {
  name: "createTarget",
  props: ["target", "branchId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      product: null,
      target: null,
      prodArray: [],
      prodList: [],
      isButtonDisabled: false,
    };
  },
  mounted() {
    this.getProductPrices();
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeCompanyModal() {
      this.$modal.hide("createTarget");
      this.getProductPrices();
    },
    getProductPrices() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.isButtonDisabled = true;
          this.showLoader = false;
          this.prodArray = response.data.map((prod) => {
            return prod.name;
          });
          this.isButtonDisabled = false;
        })
        .catch((error) => {});
    },
    updateTarget($event) {
      if (!this.target.product) {
        this.$toast.open({
          message: this.$t("text.editTargetModal.productMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.target.quantity) {
        this.$toast.open({
          message: this.$t("text.editTargetModal.targetMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        product: this.target.product,
        quantity: parseInt(this.target.quantity),
        branchId: this.branchId,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Target/UpdateBranchTarget`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$eventHub.$emit("refreshTargetsTable");
          this.isButtonDisabled = true;
          this.target = null;
          this.product = null;
          this.$toast.open({
            message: this.$t("text.editTargetModal.successfullyUpdated"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$modal.hide("editTargetModal");
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.editTargetModal.unsuccessfulUpdate"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    captureFormEvents($event) {
      if (
        $event.target.placeholder === this.$tc("text.editTargetModal.target", 1)
      ) {
        if ($event.target.value === "") {
          this.$refs.target_error.style.display = "block";
          this.$refs.target_input_div.style.border = "1px solid red";
          this.$refs.target_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.target_error.style.display = "none";
          this.$refs.target_error.innerHTML = "";
          this.$refs.target_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = false;
        }
      }
    },
  },
};
</script>
